// Shared helpers for customizable popups. Mirrors the backend logic in
// service/platform.js (validateCustomizablePopups) so the config UI can give
// instant feedback before hitting the API.

export const POPUP_LOCATIONS = ["map", "listings", "dashboard"];
export const POPUP_LANGS = ["pt", "en", "es", "it"];
export const EMPTY_SLATE = [{type: "paragraph", children: [{text: ""}]}];

const slateHasContent = (nodes) => {
    if (!Array.isArray(nodes)) return false;
    return nodes.some((n) => {
        if (!n) return false;
        if (n.type === "image" && n.url) return true;
        if (typeof n.text === "string" && n.text.trim().length > 0) return true;
        if (Array.isArray(n.children)) return slateHasContent(n.children);
        return false;
    });
};

// A Slate value is "empty" if it would render nothing (no text and no media).
export const slateIsEmpty = (value) => !slateHasContent(value);

// Slate plugin: mark image nodes as void so they render as an <img> rather than
// editable text. Apply when creating editors that render popup content.
export const withImages = (editor) => {
    const {isVoid} = editor;
    editor.isVoid = (element) => element.type === "image" ? true : isVoid(element);
    return editor;
};

// Inclusive date ranges [start, end]; a null/blank bound is open. YYYY-MM-DD
// strings order lexicographically, so plain < / > comparison is correct.
export const popupsOverlap = (a, b) => {
    const aStart = a.start_date || null, aEnd = a.end_date || null;
    const bStart = b.start_date || null, bEnd = b.end_date || null;
    if (aEnd != null && bStart != null && aEnd < bStart) return false;
    if (bEnd != null && aStart != null && bEnd < aStart) return false;
    return true;
};

// Returns the first conflicting pair among ACTIVE popups that share a location
// and overlap in date range, or null if there is none.
export const findPopupConflict = (popups) => {
    const active = popups.filter((p) => p.active);
    for (let i = 0; i < active.length; i++) {
        for (let j = i + 1; j < active.length; j++) {
            const a = active[i], b = active[j];
            const shared = (a.locations || []).filter((l) => (b.locations || []).includes(l));
            if (shared.length > 0 && popupsOverlap(a, b)) {
                return {a, b, locations: shared};
            }
        }
    }
    return null;
};
